<section class="screen-creation-dialog">
  <custom-modal-card>
    <ng-container header>
      <default-modal-header
        [title]="screen() ? 'Modifier l\'écran' : 'Créer un écran'"
        [description]="
          screen()
            ? 'Renseigner le champ ci-dessous pour la modification de l\'écran'
            : 'Renseigner le champ ci-dessous pour la création d\'un écran'
        "
      ></default-modal-header>
    </ng-container>
    <ng-container body>
      <screen-creation-form [screen]="screen()" />
    </ng-container>
  </custom-modal-card>
</section>
